/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AllergenDto
 */
export interface AllergenDto {
    /**
     * 
     * @type {string}
     * @memberof AllergenDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AllergenDto
     */
    type: string;
}

/**
 * Check if a given object implements the AllergenDto interface.
 */
export function instanceOfAllergenDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function AllergenDtoFromJSON(json: any): AllergenDto {
    return AllergenDtoFromJSONTyped(json, false);
}

export function AllergenDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllergenDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
    };
}

export function AllergenDtoToJSON(value?: AllergenDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': value.type,
    };
}

